import { TitleUI } from "./TitleUI";
import { getOwnBrand } from "../../utils/product/getOwnBrand";
import { StandardProps } from "../componentMap";
import { sanitiseTitle } from "./sanitiseTitle";
import { useSeo } from "../../hooks/useSeo/useSeo";
import { ElementType } from "react";

export function Title({
  product,
  configProps,
}: Pick<StandardProps, "product" | "configProps">) {
  const ownBrand = getOwnBrand(product);

  const overrideElement = configProps?.overrideElement as ElementType;
  const brand = (!ownBrand && product.brand?.name) || "";

  const { heading } = useSeo(product);

  const title = sanitiseTitle(heading, ownBrand, brand);
  const otherBrand = brand && heading.trim() === title ? "" : brand;

  return (
    <TitleUI
      title={title}
      ownBrand={ownBrand}
      otherBrand={otherBrand}
      element={overrideElement}
    />
  );
}
